import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { CycleCovariate } from "./cycle-covariate";
import { CycleParameter } from "./cycle-parameter";
import { CycleStatistics } from "./cycle-statistics";

@staticImplements<ResponseModelInterfaceStatic>()
export class CycleData
{
    public constructor(
        public start: Date,
        public end: Date,
        public unit: string,
        public parameters: CycleParameter[],
        public covariates: CycleCovariate[],
        public times: number[],
        public values: number[],
        public statistics: CycleStatistics|null,
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): CycleData
    {
        const start = elem.firstChildByTag("start").valueAsDate();
        const end = elem.firstChildByTag("end").valueAsDate();
        const unit = elem.firstChildByTag("unit").value();
        const times: number[] = [];
        const values: number[] = [];
        let statistics = null;

        const parameters = elem
            .firstChildByTag("parameters")
            .mapForEachChildTag("parameter", (subElem) => CycleParameter.makeFromXml(subElem));

        const covariates = elem
            .firstChildByTag("covariates")
            .mapForEachChildTag("covariate", (subElem) => CycleCovariate.makeFromXml(subElem));

        const statisticsElement = elem.firstChildByTagOrNull("statistics");
        if (statisticsElement !== null) {
            statistics = CycleStatistics.makeFromXml(statisticsElement);
        }

        // Decode time and value elements
        for (const time of elem.firstChildByTag("times").value().split(",")) {
            times.push(Number.parseFloat(time));
        }

        for (const value of elem.firstChildByTag("values").value().split(",")) {
            values.push(Number.parseFloat(value));
        }

        return new this(start, end, unit, parameters, covariates, times, values, statistics);
    }

    public getValuesByDate(): Map<Date, number>
    {
        const result = new Map<Date, number>();
        const maxIndex = Math.max(this.times.length, this.values.length);
        const msPerHour = 1000 * 60 * 60;

        for (let i = 0; i < maxIndex; i++) {
            result.set(
                new Date(this.start.getTime() + (this.times[i] * msPerHour)),
                this.values[i]
            );
        }

        return result;
    }
}
